// Libs
import React from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { useTheme } from '@material-ui/core';

// Components
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import WebIcon from '@material-ui/icons/Web';
import PermCameraMicIcon from '@material-ui/icons/PermCameraMic';
import UpdateIcon from '@material-ui/icons/Update';

// Utils
import { navigatorDetails } from 'UTILS/navigator';
import { NARROW_LAYOUT } from 'UTILS/constants';
import useTranslator from 'UTILS/hooks/useTranslator';
import translations from './locales.json';

const browserData = [
  ['os', navigatorDetails.os],
  ['browserName', navigatorDetails.browser],
  ['browserVersion', navigatorDetails.fullVersion],
  ['webRTCSupport', navigatorDetails.webRTCsupport.toString()],
  ['userAgent', window.navigator?.userAgent],
  ['platform', window.navigator?.platform],
];

const BrowserDiagnostic = () => {
  const theme = useTheme();
  const isVerbose = useSelector(state => state.app.isVerbose);
  const [translate] = useTranslator(translations);
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const hasAuthorization = useSelector(state => state.app.hasPermissions);

  const classes = cx('browserDiagnostic', {
    browserDiagnostic_largeScreen: !isSmallScreen,
  });

  return isVerbose ? (
    <Table size='small'>
      <TableBody>
        {browserData.map(([label, value]) => (
          <TableRow key={translate(label)}>
            <TableCell scope='row'>{translate(label)}</TableCell>
            <TableCell align='right'>{value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  ) : (
    <Box className={classes}>
      <Box className='browserDiagnostic-item' >
        <Box className='browserDiagnostic-label' color={theme.palette.grey[700]} >
          <WebIcon />
          <Typography variant='body2' className='browserDiagnostic-labelText' >{translate('browserName')}</Typography>
        </Box>
        {!isSmallScreen && <Divider />}
        <Typography variant='subtitle2' className='browserDiagnostic-valueText'>{navigatorDetails.browserName}</Typography>
      </Box>
      {isSmallScreen && <Divider />}
      <Box className='browserDiagnostic-item' >
        <Box className='browserDiagnostic-label' color={theme.palette.grey[700]} >
          <UpdateIcon />
          <Typography variant='body2' className='browserDiagnostic-labelText' >{translate('browserVersion')}</Typography>
        </Box>
        {!isSmallScreen && <Divider />}
        <Typography variant='subtitle2' className='browserDiagnostic-valueText'>{navigatorDetails.version}</Typography>
      </Box>
      {isSmallScreen && <Divider />}
      <Box className='browserDiagnostic-item'>
        <Box className='browserDiagnostic-label' color={theme.palette.grey[700]} >
          <PermCameraMicIcon />
          <Typography variant='body2' className='browserDiagnostic-labelText'>{translate('mediaAccess')}</Typography>
        </Box>
        {!isSmallScreen && <Divider />}
        <Typography variant='subtitle2' className='browserDiagnostic-valueText' >{hasAuthorization ? translate('authorized') : translate('unauthorized')}</Typography>
      </Box>
    </Box>
  );
};

export default BrowserDiagnostic;
